<template>
  <div class="tw-bg-purple-50 tw-px-6">
    <TooltipTour
      ref="tour"
      :steps="tour"
      :show="showSelfServeAttentionTabTutorial"
      tourName="self_serve_interested"
      @tour-finished="handleTourFinished"
    />
    <div
      v-if="isLoading || (isCandidateOpen && loading)"
      class="loading-progress"
    >
      <v-progress-circular
        :size="72"
        :width="6"
        color="primary"
        indeterminate
        class="ma-auto"
      ></v-progress-circular>
    </div>
    <div
      v-if="isCandidateOpen"
      class="tw-h-[44px] tw-bg-bg-2 tw-px-6 tw-py-2 tw-flex tw-justify-between tw-items-center tw-w-full tw-rounded-lg"
    >
      <div class="tw-flex tw-items-center tw-gap-6">
        <div class="tw-cursor-pointer" @click="onCloseReviewCandidate">
          <img :src="BackIcon" />
        </div>
        <div v-if="currentHistoryMessage">
          <Typography variant="body-2">
            {{ currentHistoryMessage }}
          </Typography>
        </div>
        <div class="tw-cursor-pointer" @click="onOpenRightdrawer(0)">
          <Typography
            variant="button-2"
            class="tw-flex tw-items-center tw-gap-2 tw-text-purple-600"
            ><img :src="EmailIcon"
          /></Typography>
        </div>
        <div v-if="selectedCandidates.length">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <Button variant="text">
                <div
                  class="tw-flex tw-items-center tw-gap-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <div>
                    <img :src="MoveIcon" />
                  </div>
                  <Typography
                    variant="button-2"
                    class="tw-cursor-pointer tw-text-purple-600"
                  >
                    Move to
                  </Typography>
                </div>
              </Button>
            </template>
            <div
              class="tw-bg-white tw-rounded-lg tw-w-[240px] tw-shadow-shadow-2"
            >
              <div v-for="item in filteredTabs" :key="item.key">
                <div
                  v-if="item.tab !== 'Interested'"
                  class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                  @click="onMoveCandidate(item.key)"
                >
                  {{ `Move to ${item.tab}` }}
                </div>
                <div v-else>
                  <v-tooltip top :disabled="!disabledMoveCandidate">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <div
                          variant="text"
                          :disabled="disabledMoveCandidate"
                          class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                          @click="onMoveCandidateInterested(item.key)"
                        >
                          {{ `Move to ${item.tab}` }}
                        </div>
                      </div>
                    </template>
                    <span
                      >Selected candidate(s) ineligible for Interested.</span
                    >
                  </v-tooltip>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <div v-if="selectedCandidates.length">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <IconButton class="tw-group tw-relative" v-bind="attrs" v-on="on">
                <img :src="KebabIcon" />
                <div
                  class="-tw-mt-2 group-hover:tw-block tw-hidden tw-bg-gray-700 tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-white tw-absolute tw-top-full tw-right-0 tw-whitespace-nowrap"
                >
                  <Typography variant="body-2">More actions</Typography>
                </div>
              </IconButton>
            </template>
            <div class="tw-bg-white tw-rounded-lg">
              <div
                class="tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-purple-100"
                @click="onOpenRightdrawer(3)"
              >
                Activity history
              </div>
              <div
                class="tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-purple-100"
                @click="onOpenRightdrawer(1)"
              >
                Chat
              </div>
              <div
                v-if="selectedCandidates.length && selectedCandidates[0]?.notes"
                class="tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-purple-100"
                @click="onOpenRightdrawer(2)"
              >
                Note
              </div>
              <div
                v-if="tab !== 'REJECTED' && tab !== 'NOT_INTERESTED'"
                class="tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-purple-100"
                @click="shareExportCandidate(0)"
              >
                <Typography variant="body-2">Share Candidates</Typography>
              </div>
              <div
                class="tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-purple-100"
                @click="shareExportCandidate(1)"
              >
                <Typography variant="body-2">Export as CSV</Typography>
              </div>
            </div>
          </v-menu>
        </div>
      </div>
      <div>
        <div
          v-if="totalCandidates > 1"
          class="tw-flex tw-items-center tw-gap-3"
        >
          <Typography variant="body-1" class="tw-whitespace-nowrap">
            {{ (page - 1) * limit + candIdx + 1 }} of
            {{ totalCandidates }}
          </Typography>
          <div class="tw-flex tw-gap-3">
            <v-btn
              icon
              width="20px"
              height="20px"
              color="#384955"
              :disabled="candIdx === 0 && page === 1"
              @click="onPrev1x1Candidate()"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              width="20px"
              height="20px"
              color="#384955"
              :disabled="candIdx === totalCandidates - 1"
              @click="onNext1x1Candidate()"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <Typography variant="body-1"
            >1 of {{ candidateDisplay.length }}</Typography
          >
        </div>
      </div>
    </div>
    <div
      v-else-if="candidateDisplay.length"
      class="tw-sticky tw-top-[109px] tw-z-10 tw-bg-purple-50 py-1"
      :class="{ '!tw-top-[163px]': isShowSessionSwitcher }"
    >
      <div
        class="tw-h-[44px] tw-bg-purple-100 tw-px-6 tw-py-2 tw-flex tw-justify-between tw-items-center tw-w-full tw-rounded-lg"
      >
        <div class="tw-flex tw-items-center tw-gap-6">
          <div>
            <div v-if="totalCandidates > limit">
              <v-menu v-model="selectedMenu" bottom nudge-bottom="35px">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="tw-flex tw-items-center tw-items-center"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-checkbox
                      :model-value="
                        selectedCandidates.length === totalCandidates
                      "
                      hide-details
                      readonly
                      color="#5656B2"
                      :indeterminate="
                        selectedCandidates.length > 0 &&
                        selectedCandidates.length < totalCandidates
                      "
                    ></v-checkbox>
                    <div class="tw-pr-2 tw-cursor-pointer">
                      <img :src="ArrowIcon" />
                    </div>
                    <Typography variant="button-1" class="tw-cursor-pointer">
                      <div v-if="selectedCandidates.length">
                        {{ selectedCandidates.length }} selected
                      </div>
                      <div v-else>Select all</div>
                    </Typography>
                  </div>
                </template>
                <div class="tw-bg-white tw-w-[200px] tw-rounded-lg">
                  <div
                    class="tw-px-4 tw-py-2 hover:tw-bg-purple-100 tw-cursor-pointer"
                    @click="handleSelectAll(false)"
                  >
                    None
                  </div>
                  <div
                    class="tw-px-4 tw-py-2 hover:tw-bg-purple-100 tw-cursor-pointer"
                    @click="handleSelectAll(candidateDisplay.length)"
                  >
                    <Typography variant="body-2"
                      >{{ candidateDisplay.length }}
                      {{
                        `candidate${candidateDisplay.length === 1 ? '' : 's'}`
                      }}</Typography
                    >
                  </div>
                  <div
                    v-if="totalCandidates > limit"
                    class="tw-px-4 tw-py-2 hover:tw-bg-purple-100 tw-opacity-30"
                  >
                    <Typography variant="body-2">Select all</Typography>
                  </div>
                </div>
              </v-menu>
            </div>
            <div
              v-else
              class="tw-flex tw-items-center tw-items-center"
              @click="handleSelectAll(!selectAll)"
            >
              <v-checkbox
                :value="selectedCandidates.length === totalCandidates"
                hide-details
                readonly
                :indeterminate="
                  selectedCandidates.length > 0 &&
                  selectedCandidates.length < totalCandidates
                "
              ></v-checkbox>
              <Typography variant="button-1" class="tw-cursor-pointer">
                <div v-if="selectedCandidates.length">
                  {{ selectedCandidates.length }} selected
                </div>
                <div v-else>Select all</div>
              </Typography>
            </div>
          </div>

          <div v-if="selectedCandidates.length">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="tw-cursor-pointer hover:tw-bg-highlight tw-p-1 tw-rounded-lg tw-transition-all tw-ease-in-out"
                >
                  <div
                    class="tw-flex tw-items-center tw-gap-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div>
                      <img :src="MoveIcon" />
                    </div>
                    <Typography
                      variant="button-2"
                      class="tw-cursor-pointer tw-text-purple-600"
                    >
                      Move to
                    </Typography>
                  </div>
                </div>
              </template>
              <div
                class="tw-bg-white tw-rounded-lg tw-w-[240px] tw-shadow-shadow-2"
              >
                <div v-for="item in filteredTabs" :key="item.key">
                  <div
                    v-if="item.tab !== 'Interested'"
                    class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                    @click="onMoveCandidate(item.key)"
                  >
                    {{ `Move to ${item.tab}` }}
                  </div>
                  <div v-else>
                    <v-tooltip top :disabled="!disabledMoveCandidate">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <div
                            variant="text"
                            :disabled="disabledMoveCandidate"
                            class="tw-px-4 tw-py-2 hover:tw-bg-highlight tw-cursor-pointer"
                            @click="onMoveCandidateInterested(item.key)"
                          >
                            {{ `Move to ${item.tab}` }}
                          </div>
                        </div>
                      </template>
                      <span
                        >Selected candidate(s) ineligible for Interested.</span
                      >
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <div v-if="selectedCandidates.length">
            <div
              class="tw-cursor-pointer hover:tw-bg-highlight tw-p-1 tw-rounded-lg tw-transition-all tw-ease-in-out"
              variant="text"
              @click="shareExportCandidate(1)"
            >
              <div class="tw-flex tw-items-center tw-gap-2">
                <div>
                  <img :src="FileDownload" />
                </div>
                <Typography
                  variant="button-2"
                  class="tw-cursor-pointer tw-text-purple-600"
                >
                  Export as CSV
                </Typography>
              </div>
            </div>
          </div>
          <div
            v-if="
              tab !== 'REJECTED' &&
              tab !== 'NOT_INTERESTED' &&
              selectedCandidates.length
            "
          >
            <div
              class="tw-cursor-pointer hover:tw-bg-highlight tw-p-1 tw-rounded-lg tw-transition-all tw-ease-in-out"
              variant="text"
              @click="shareExportCandidate(0)"
            >
              <div class="tw-flex tw-items-center tw-gap-2 tw-text-purple-600">
                <div>
                  <v-icon color="#5656B2">mdi mdi-share</v-icon>
                </div>
                <Typography variant="button-2" class="tw-cursor-pointer">
                  Share Candidates
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div v-if="lengthPage > 1" class="tw-flex tw-items-center tw-gap-3">
            <Typography variant="body-1" class="tw-whitespace-nowrap">
              {{ (page - 1) * limit + 1 }} -
              {{ (page - 1) * limit + candidateDisplay.length }} of
              {{ totalCandidates }}
            </Typography>
            <div class="tw-flex tw-gap-3">
              <v-btn
                icon
                width="20px"
                height="20px"
                color="#384955"
                :disabled="page === 1"
                @click="handlePrev()"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                icon
                width="20px"
                height="20px"
                color="#384955"
                :disabled="page === lengthPage"
                @click="handleNext()"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
          <div v-else>
            <Typography variant="body-1"
              >1 -{{ candidateDisplay.length }} of
              {{ candidateDisplay.length }}</Typography
            >
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="isCandidateOpen" class="tw-pt-6 tw-pb-20">
        <CardV2
          v-if="!candidateLoading"
          :candidate="candidateDisplay[candIdx]"
          :hideActions="true"
          :tab="tab"
          :projectId="projectId"
          :isInCalibration="false"
          :displayClipBoard="displayClipBoard"
          :projectData="projectData"
          :currentTab="currentTab"
          @expand-email="onOpenRightdrawer(0)"
        />
      </div>
      <div v-else>
        <div
          v-if="candidateDisplay.length"
          ref="candidates-container"
          @scroll="onScroll"
        >
          <div>
            <div class="tw-grid tw-grid-cols-2 tw-gap-6 tw-py-5">
              <div
                v-for="candidate in candidateDisplay"
                :key="candidate._id"
                class="grid-item"
              >
                <CompactCardV2
                  v-if="!candidate.contacted"
                  :id="`candidate_${candidate.id}`"
                  ref="candidate-select"
                  :candidate="candidate"
                  :tab="tab"
                  :tabs="tabs"
                  :isPilot="isAutopilot"
                  :projectId="projectId"
                  :disabledMoveCandidate="disabledMoveCandidate"
                  :loading="loading"
                  :isSelected="
                    selectedCandidates.filter(
                      (item) => item._id === candidate._id
                    )?.length > 0
                  "
                  @is-show-menu="showReasonMenu"
                  @open="openCandidate(candidate)"
                  @select="onSelectCandidates(candidate)"
                  @shareExport="shareExportCandidate($event, candidate)"
                  @move="onMoveCandidate($event, candidate)"
                  @email="onMailClick(candidate)"
                  @activityHistory="onActivityHistory(candidate)"
                  @chat="onChatClick(candidate)"
                  @note="onOpenRightdrawer(2)"
                />
              </div>
            </div>
          </div>
        </div>

        <EmptyState
          v-if="candidateDisplay.length === 0 && !isLoading && !loading"
          :image="EmptyStateIcon"
          text="No candidates yet"
        />
      </div>
    </div>
    <SidePanel
      v-if="this.projectId && candidateDisplay.length"
      ref="sidePanelRef"
      :candidates="selectedCandidates"
      :projectId="projectId"
      :tab="tab"
      :candidate-update-function="selectedCandidates"
      expanded
      :isShowIntro="isShowIntro2"
      @unselectCandidate="handleUnselectCandidate"
    >
    </SidePanel>
    <v-dialog v-model="dialog" max-width="820"> </v-dialog>

    <v-dialog v-model="shareDialog" max-width="640">
      <ShareDialog
        :projectId="projectId"
        :candidates="selectedCandidates"
        @emailSent="handleEmailSent"
      />
    </v-dialog>

    <v-snackbar v-model="confirmSnackbar" top>
      <strong>Candidate has been updated</strong>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="confirmSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import STATUS from '@/store/status';
import CompactCardV2 from '@/components/card/CompactCardV2';
import CardV2 from '@/components/card/CardV2';
import { defaultCandidate, selfServeAttentionTour } from '@/js/data';
import { sleep } from '@/utils/';

import Typography from '@/components/v3/base/Typography';
import ArrowIcon from '@/assets/icons/chevron-down.svg';
import MoveIcon from '@/assets/icons/switch-purple.svg';
import Button from '@/components/v3/base/Button';
import FileDownload from '@/assets/icons/file-download-03.svg';
import KebabIcon from '@/assets/icons/kebab-purple.svg';
import BackIcon from '@/assets/icons/arrow-left.svg';
import IconButton from '@/components/v3/base/IconButton';
import { tabsOrder, tabsNames } from '@/components/v3/widgets/tabs.ts';
import EmailIcon from '@/assets/icons/mail-purple.svg';
import EmptyStateIcon from '@/assets/icons/empty-state-icon.png';
import SidePanel from './SidePanel';
import ShareDialog from './ShareDialog';
import EmptyState from './EmptyState';

const EMPTY_STATE_IMAGE = require('@/assets/img/empty-review.png');
const EMPTY_STATE_REVIEW_IMAGE = require('@/assets/img/empty-review.png');
const EMPTY_STATE_APPROVED_IMAGE = require('@/assets/img/empty-approved.png');
const EMPTY_STATE_CONTACTED_IMAGE = require('@/assets/img/empty-contacted.png');
const EMPTY_STATE_INTERVIEW_IMAGE = require('@/assets/img/empty-interview.png');
const EMPTY_STATE_REJECTED_IMAGE = require('@/assets/img/empty-rejected.png');
const EMPTY_STATE_NOT_INTERESTED_IMAGE = require('@/assets/img/empty-not-interested.png');

export default {
  components: {
    CompactCardV2,
    SidePanel,
    CardV2,
    ShareDialog,
    EmptyState,
    TooltipTour: () => import('@/components/information-tours/TooltipTour'),
    Typography,
    Button,
    IconButton,
  },

  props: {
    projectId: String,
    tab: String,
    tabs: Array,
    isAutopilot: Boolean,
    totalCandidates: [Number, String],
    isShowIntro2: Boolean,
    isSelfServe: Boolean,
    displayClipBoard: Boolean,
    currentTab: [String, Number, Boolean],
    projectData: {
      type: Object,
      default: () => {},
    },

    isShowSessionSwitcher: Boolean,
  },

  data() {
    return {
      isScroll: false,
      selectAll: false,
      selectedCandidates: [],
      tour: selfServeAttentionTour,
      showTour: false,
      dialog: false,
      shareDialog: false,
      dialogCandidate: undefined,
      loading: false,
      searchedCand: this.$root._route.query.candidate,
      limit: 50,
      page: 1,
      nextTab: '',
      confirmSnackbar: false,
      shareAndExport: null,
      candidateLoading: false,
      ArrowIcon,
      MoveIcon,
      FileDownload,
      isCandidateOpen: false,
      KebabIcon,
      BackIcon,
      candIdx: 0,
      EmailIcon,
      EmptyStateIcon,
      selectedMenu: false,
    };
  },

  computed: {
    projects() {
      return this.$store.getters['projects/listProjects'];
    },

    currentProject() {
      if (!this.projectId) {
        return {};
      }

      return this.projects.find(
        (project) => project.project_id === this.projectId
      );
    },

    filteredTabs() {
      if (!Array.isArray(this.tabs)) return [];

      return this.tabs.filter(
        (t) => t.key !== 'review' && t.key !== this.tab.toLowerCase()
      );
    },

    status() {
      const tab = this.tab;
      return this.$store.getters['projects/candidates/getStatus'](
        this.projectId,
        tab
      );
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },

    candidates() {
      const tab = this.tab;
      return (
        this.$store.getters['projects/candidates/listCandidates'](
          this.projectId,
          tab
        ) || []
      );
    },

    candidateDisplay() {
      if (this.isShowIntro2 && !this.candidates.length) {
        return defaultCandidate;
      }

      return this.candidates;
    },

    lengthPage() {
      return (
        Math.floor(this.totalCandidates / this.limit) +
        (this.totalCandidates % this.limit > 0 ? 1 : 0)
      );
    },

    isLoading() {
      return this.status === STATUS.LOADING;
    },

    emptyStateImage() {
      if (this.tab === 'UNDER_REVIEW') {
        return EMPTY_STATE_REVIEW_IMAGE;
      }
      if (this.tab === 'APPROVED') {
        return EMPTY_STATE_APPROVED_IMAGE;
      }
      if (this.tab === 'CONTACTED') {
        return EMPTY_STATE_CONTACTED_IMAGE;
      }
      if (this.tab === 'INTERVIEWING') {
        return EMPTY_STATE_INTERVIEW_IMAGE;
      }
      if (this.tab === 'NOT_INTERESTED') {
        return EMPTY_STATE_NOT_INTERESTED_IMAGE;
      }
      if (this.tab === 'REJECTED') {
        return EMPTY_STATE_REJECTED_IMAGE;
      }
      return EMPTY_STATE_IMAGE;
    },

    emptyStateText() {
      if (this.tab === 'APPROVED') {
        return this.$lang.Panel.null_title_approved;
      }
      if (this.tab === 'CONTACTED') {
        return this.$lang.Panel.null_title_contacted;
      }
      if (this.tab === 'INTERVIEWING') {
        return this.$lang.Panel.null_title_interviewing;
      }
      if (this.tab === 'NOT_INTERESTED') {
        return this.$lang.Panel.null_title_not_interested;
      }
      if (this.tab === 'REJECTED') {
        return this.$lang.Panel.null_title_rejected;
      }
      return this.$lang.Panel.null_title_empty;
    },

    candidateWasAutoSwiped() {
      return this.selectedCandidates.filter(
        (candidate) => !candidate.was_auto_swiped
      ).length;
    },

    isOwner() {
      return (
        !this.currentProject.is_warmleads_recruiter || // TODO(jeremiah): delete this line after v2 rollout
        this.$store.getters['user/getIsSuperAdmin']
      );
    },

    disabledMoveCandidate() {
      return (
        this.isOwner &&
        (this.tab === 'NOT_INTERESTED' ||
          (this.tab === 'REJECTED' && this.candidateWasAutoSwiped > 0))
      );
    },

    showSelfServeAttentionTabTutorial() {
      if (!this.isSelfServe) return false;
      if (this.showTour) return true;
      if (this.candidates.length === 0) {
        return false;
      }
      const user = this.$store.getters['user/getUser'];
      if (
        !user.onboarding_tours ||
        user.onboarding_tours.self_serve_interested
      ) {
        return false;
      }
      return true;
    },

    currentHistoryMessage() {
      const history = this.candidateDisplay[this.candIdx]?.history ?? [];
      if (!history.length) return '';
      const lastHistory = history[history.length - 1];
      const tabName = tabsOrder[lastHistory.event]
        ? tabsNames[tabsOrder[lastHistory.event].toLowerCase()]
        : '';
      return ` Moved to
            ${tabName}
            on
            ${lastHistory.date}`;
    },
  },

  watch: {
    searchedCand() {
      setTimeout(() => {
        this.routeCandidate(this.searchedCand);
      }, 500);
    },

    async showSelfServeAttentionTabTutorial(v) {
      if (!v) return;
      let candidatesReady = false;
      while (!candidatesReady) {
        // eslint-disable-next-line no-await-in-loop, no-promise-executor-return
        await sleep(1000);
        if (this.$refs['candidate-select']) candidatesReady = true;
      }
      if (this.$refs['candidate-select'] === null) return;
      const component = this.$refs['candidate-select'][0];
      component.setSelected(true);
      this.selectedCandidates = [component.candidate];
    },

    currentTab() {
      this.selectedCandidates = [];
      this.isCandidateOpen = false;
    },

    page() {
      this.selectedCandidates = [];
    },

    candidateDisplay() {
      const selectedIds = this.selectedCandidates.map((item) => item._id);
      this.selectedCandidates = this.candidateDisplay.filter((cand) =>
        selectedIds.includes(cand._id)
      );
    },
  },

  beforeDestroy() {
    this.searchedCand = '';
  },

  async created() {
    await this.loadCandidatePaging(1);
    if (this.searchedCand) {
      if (document.getElementById(`candidate_${this.searchedCand}`)) {
        setTimeout(() => {
          this.routeCandidate(this.searchedCand);
        }, 500);
      }
    }
  },

  mounted() {
    this.$root.$refs.tabcompact = this;
    const candidateId = this.$route.query.candidate;
    if (candidateId) {
      this.getPaging(candidateId);
    }
  },

  methods: {
    async loadCandidatePaging(page) {
      // TODO(jeremiah): clean this up after v2 rollout
      const tab = this.tab;
      await this.$store.dispatch('projects/candidates/loadCandidates', {
        projectId: this.projectId,
        tab,
        pageIdx: page,
        tmp: true,
      });
    },

    showReasonMenu() {
      this.isScroll = false;
    },

    onScroll() {
      if (this.isScroll === false) {
        this.isScroll = true;
      }
    },

    async handleNext() {
      this.page += 1;
      await this.loadCandidatePaging(this.page);
    },

    async handlePrev() {
      this.page -= 1;
      await this.loadCandidatePaging(this.page);
    },

    async onPrev1x1Candidate() {
      if (this.candIdx <= 0) {
        await this.handlePrev();
        this.candIdx = this.candidateDisplay.length - 1;
      } else {
        this.candIdx -= 1;
      }
      this.selectedCandidates = [this.candidateDisplay[this.candIdx]];
    },

    async onNext1x1Candidate() {
      if (this.candIdx >= this.candidateDisplay.length - 1) {
        await this.handleNext();
        this.candIdx = 0;
      } else {
        this.candIdx += 1;
      }
      this.selectedCandidates = [this.candidateDisplay[this.candIdx]];
    },

    selectCandidates(cand) {
      const idx = this.selectedCandidates.findIndex(
        (item) => item._id === cand._id
      );
      if (idx < 0) {
        this.selectedCandidates.push(cand);
      } else {
        this.selectedCandidates.splice(idx, 1);
      }
    },

    handleSelectAll(val) {
      this.selectAll = val;
      if (val) {
        this.selectedCandidates = [...this.candidateDisplay];
      } else {
        this.selectedCandidates = [];
      }
    },

    updateSelectedCandidates() {
      if (this.isCandidateOpen) return;
      const allCandidates = this.$refs['candidate-select'];
      const currentSelectedCandidates = allCandidates
        .filter((component) => component.isSelected())
        .map((component) => component.candidate);
      this.selectedCandidates.splice(
        0,
        this.selectedCandidates.length,
        ...currentSelectedCandidates
      );
    },

    handleUnselectCandidate(cand) {
      const idx = this.selectedCandidates.findIndex(
        (item) => item._id === cand._id
      );
      if (idx >= 0) {
        this.selectedCandidates.splice(idx, 1);
      }
    },

    openCandidate(candidate) {
      this.selectedCandidates = [candidate];

      this.candIdx = this.candidateDisplay.findIndex(
        (c) => c._id === candidate._id
      );

      this.isCandidateOpen = true;
    },

    // Called from vue router
    routeCandidate(candidateId) {
      const candidate = this.candidateDisplay.find(
        (cand) => cand.candidate._id === candidateId
      );
      if (!candidate) {
        return;
      }
      this.selectCandidates.push(candidate);
      // Delay a while and scroll to the candidate.
      // The delay is to accomodate other vuetify animations.
      this.$nextTick(() => {
        this.$vuetify.goTo(candidate, {
          container: this.$refs['candidates-container'],
        });
      });
    },

    async confirmMovingCandidate() {
      if (!this.nextTab && !this.shareAndExport && this.shareAndExport !== 0)
        return;
      if (this.nextTab) {
        await this.setNewState(this.nextTab.toUpperCase());

        if (this.isCandidateOpen) {
          if (this.candidates.length === 0) {
            this.isCandidateOpen = false;
            this.selectedCandidates = [];
            this.candIdx = 0;
          } else {
            this.selectedCandidates = this.candidates.length
              ? [this.candidates[0]]
              : [];
            this.candIdx = 0;
          }
        } else {
          this.selectedCandidates = [];
        }
      }
      if (this.shareAndExport === 0) {
        this.shareCandidates();
      } else if (this.shareAndExport === 1) {
        this.exportCSV();
      }
      this.shareAndExport = null;
      this.nextTab = null;
    },

    async setNewStateV2(newStatus) {
      const newTab = newStatus;
      const promises = this.selectedCandidates.map((candidate) =>
        this.$store.dispatch('projects/candidates/moveCandidate', {
          projectId: this.projectId,
          tab: this.tab.toUpperCase(),
          candidate,
          newTab: newTab.toUpperCase(),
        })
      );

      try {
        this.loading = true;
        await Promise.all(promises);
        this.confirmSnackbar = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.nextTab = '';
      }
    },

    async setNewState(newStatus) {
      // TODO(jeremiah): clean this up after v2 rollout
      if (this.isV2) {
        await this.setNewStateV2(newStatus);
        return;
      }
      if (newStatus === 'REJECTED') {
        const promises = this.selectedCandidates.map((candidate) =>
          this.$store.dispatch('projects/candidates/updateCandidateState', {
            projectId: this.projectId,
            tab: this.tab,
            candidateId: candidate._id,
            newTab: newStatus,
            payload: {
              rejection_code: 11,
              rejection_reason_other: 'Manually transitioned to rejected',
            },
          })
        );

        try {
          this.loading = true;
          await Promise.all(promises);
          this.confirmSnackbar = true;
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
          this.nextTab = '';
        }
      } else {
        const promises = this.selectedCandidates.map((candidate) =>
          this.$store.dispatch('projects/candidates/updateCandidateState', {
            projectId: this.projectId,
            tab: this.tab,
            candidateId: candidate._id,
            newTab: newStatus,
          })
        );

        try {
          this.loading = true;
          await Promise.all(promises);
          this.confirmSnackbar = true;
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
          this.nextTab = '';
        }
      }
      if (!this.candidateDisplay.length) {
        this.loadCandidatePaging(this.page);
      }
    },

    handleTourFinished() {
      this.showTour = false;
      this.$emit('tour-finished', 'self_serve_interested');
    },

    exportCSV() {
      function exportToCsvHelper(filename, rows) {
        const processRow = (row) => {
          let finalVal = '';
          for (let j = 0; j < row.length; j++) {
            let innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
              innerValue = row[j].toLocaleString();
            }
            let result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0) {
              result = `"${result}"`;
            }
            if (j > 0) {
              finalVal += ',';
            }
            finalVal += result;
          }
          return `${finalVal}\n`;
        };

        let csvFile = '';
        for (let i = 0; i < rows.length; i++) {
          csvFile += processRow(rows[i]);
        }

        const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }

      const csvRows = [];
      csvRows.push([
        'Name',
        'LinkedIn Profile',
        'Title',
        'Company',
        'Location',
        'Personal Emails',
      ]);

      this.selectedCandidates.forEach((candidate) => {
        let email = '';
        if (candidate.personal_emails !== null) {
          email = candidate.personal_emails[0];
        }

        const infoToWrite = [
          candidate.name,
          candidate.linkedin_profile_url,
          candidate.experiences[0].title,
          candidate.experiences[0].company,
          candidate.location,
          candidate.personal_emails,
        ];
        for (let i = 0; i < infoToWrite.length; i++) {
          if (infoToWrite[i] === undefined || infoToWrite[i] == null) {
            infoToWrite[i] = '';
          }
        }
        csvRows.push(infoToWrite);
      });

      exportToCsvHelper('HireflyCandidates', csvRows);
    },

    shareCandidates() {
      this.shareDialog = true;
    },

    handleEmailSent() {
      this.shareDialog = false;
    },

    getPaging(id) {
      const _page = this.$store.getters['projects/candidates/getPaging'](
        this.projectId,
        this.tab,
        id,
        this.limit
      );
      this.page = _page;
    },

    shareExportCandidate(val, cand) {
      // this.updateSelectedCandidates();
      this.shareAndExport = val;
      if (cand) {
        this.selectCandidateBeforeActions(cand);
      }

      this.confirmMovingCandidate();
    },

    onMoveCandidate(val, cand) {
      // this.updateSelectedCandidates();
      this.nextTab = val;
      if (cand) {
        this.selectCandidateBeforeActions(cand);
      }
      this.confirmMovingCandidate();
    },

    onMoveCandidateInterested(val) {
      if (this.disabledMoveCandidate) return;
      this.onMoveCandidate(val);
    },

    onCloseReviewCandidate() {
      this.isCandidateOpen = false;
      this.selectedCandidates = [];
    },

    onOpenRightdrawer(val) {
      this.$refs.sidePanelRef?.onOpen(val);
    },

    onSelectCandidates(cand) {
      const idx = this.selectedCandidates.findIndex(
        (item) => item._id === cand._id
      );
      if (idx < 0) {
        this.selectedCandidates.push(cand);
      } else {
        this.selectedCandidates.splice(idx, 1);
      }
    },

    selectCandidateBeforeActions(cand) {
      if (
        this.selectedCandidates.filter((c) => c._id === cand._id).length === 0
      ) {
        this.selectedCandidates.push(cand);
      }
    },

    onMailClick(cand) {
      this.selectCandidateBeforeActions(cand);
      this.onOpenRightdrawer(0);
    },

    onActivityHistory(cand) {
      this.selectCandidateBeforeActions(cand);
      this.onOpenRightdrawer(3);
    },

    onChatClick(cand) {
      this.selectCandidateBeforeActions(cand);
      this.onOpenRightdrawer(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.custom-container {
  max-width: 866px;
  margin: 0 auto;
  padding: 0 20px;
  position: absolute;
  background: #e9e9e9;
  z-index: 10;
  top: 0px;
  left: 0px;
  width: 100%;
}

.import-candidate {
  background: #fff;
  box-shadow: -1px 1px 8px rgba(0, 0, 0, 0.3) !important;
  border-radius: 4px;
  height: auto !important;
  padding: 7px 16px !important;
  &::v-deep .v-badge--icon {
    margin-top: -1px;
  }
  &::v-deep .v-badge__badge {
    min-width: 0;
    width: 14px;
    height: 14px;
    background: none !important;
    color: $primary-dark;
    &::after {
      border: none;
    }
    i {
      font-size: 14px;
      &::before {
        font-weight: 700;
      }
    }
  }
  .import-candidate-text {
    margin-left: 12px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.3px;
    color: $primary-dark;
  }
}

.contents {
  width: 100%;
}
.cards-block {
  padding-top: 82px;
  position: relative;
  z-index: 1;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #d4d4d8;
  }
  .card-grid {
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 60px 66px;
  }
}

.import-button-side-panel {
  right: 20rem;
  top: 0.5rem;
}

.import-button-no-side-panel {
  right: 5rem;
  top: 0.5rem;
}
.select-all-checkbox {
  &::v-deep .v-icon {
    display: none;
    &.mdi-checkbox-marked {
      display: inline-flex;
    }
  }
  &::v-deep .v-input--selection-controls__input {
    border: 2px solid #d8d8d8;
    background: #fff;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  &::v-deep .v-input--selection-controls__ripple {
    left: -16px;
  }
  &::v-deep label {
    color: #384955;
    font-size: 14px;
    font-weight: 500;
  }
}
.select-button {
  background: #fff;
  margin-left: 9px;
  padding: 7px 24px !important;
  height: auto !important;
  &::v-deep .v-btn__content {
    color: #384955;
    font-size: 14px;
    font-weight: 500;
    align-items: center;
  }
  &::v-deep .v-icon--right {
    margin-left: 40px;
    font-size: 30px;
    color: #000;
  }
  &::v-deep .v-btn:before {
    opacity: 0;
  }
}
.select-list {
  margin-top: 4px;
  border-radius: 4px;
  box-shadow: -2px 2px 12px rgba(0, 0, 0, 0.4) !important;
  &::v-deep .v-list-item__title,
  &::v-deep .theme--light.v-label {
    color: #384955;
    font-size: 14px;
  }
  &::v-deep .v-list-item {
    &:hover {
      background: #e6e7eb;
    }
    min-height: 0px;
    padding: 7px 24px;
    margin: 5px 0;
  }
}
.gap-60 {
  gap: 60px;
}
.margin-box {
  padding-right: 336px;
}
.top-paging {
  ::v-deep .v-pagination__item,
  ::v-deep .v-pagination__more {
    display: none;
  }
  ::v-deep .v-pagination__item--active {
    display: block;
  }
  ::v-deep .v-pagination__navigation.v-pagination__navigation--disabled {
    display: none;
  }
}
.select-all-box {
  max-width: unset !important;
  width: 100% !important;
  padding-right: 336px;
}
.pagination-box {
  width: 114px;
  height: 32px;
  background-color: #fff;
  border-radius: 4px;
  &__nums {
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.23px;
    color: $gray-dark;
    padding: 0 8px 0 8px;
  }
}
.grid-item > div {
  height: 100%;
}
.loading-progress {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 100;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay2 {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 2;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.z-1 {
  z-index: 0;
}
::v-deep {
  .v-input--selection-controls {
    margin-top: 0px !important;
  }
}
</style>
